var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import theme from '../../theme';
import { pxToRem } from '../../utils/pxToRem';
var _a = theme.labels, fontFamily = _a.fontFamily, textTransform = _a.textTransform, letterSpacing = _a.letterSpacing, fontWeight = _a.fontWeight;
// In px in theme folder
var lineHeight = {
    small: 12,
    medium: 14,
    large: 16,
    extraLarge: 20,
};
export var LabelStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  letter-spacing: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"], ["\n  font-family: ", ";\n  letter-spacing: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"])), fontFamily, letterSpacing, fontWeight, textTransform);
export var LabelStylesRem = function (size) { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n  line-height: ", ";\n"])), LabelStyles, pxToRem(theme.labels[size].fontSize), pxToRem(lineHeight[size])); };
export var LabelStylesPx = function (size) { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  font-size: ", "px;\n  line-height: ", ";\n"], ["\n  ", "\n  font-size: ", "px;\n  line-height: ", ";\n"])), LabelStyles, theme.labels[size].fontSize, theme.labels[size].lineHeight); };
var templateObject_1, templateObject_2, templateObject_3;
